module.exports = __webpack_public_path__ + "img/artemisads-logo.650076c6.svg";